import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/apps/admin/login/page.tsx");
